import { render, staticRenderFns } from "./animalStrength.vue?vue&type=template&id=7c3a4468&scoped=true&"
import script from "./animalStrength.vue?vue&type=script&lang=js&"
export * from "./animalStrength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a4468",
  null
  
)

export default component.exports